export class SaasEntityTypeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<SaasEntityType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<SaasEntityType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasEntityTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
